<template>
    <template-layout fullheader="true">
        <template slot="header">
            <div class="container">
                <div class="columns">
                    <div class="column"></div>

                    <div v-if="code !== ''" class="column">
                        <!--Password request was sent-->
                        <div v-if="passwordChanged" class="box">
                            <h1 class="title">Recuperar cuenta</h1>
                            <span>Tu contraseña ha sido cambiada, ya podés volver a ingresar.</span>

                            <b-field>
                                <router-link class="button is-primary" :to="{ name: 'Login' }">Ingresar</router-link>
                            </b-field>
                        </div>

                        <!--Enter a new password-->
                        <div v-else class="box">
                            <h1 class="title">Recuperar cuenta</h1>
                            <span>Ingresa una nueva contraseña para tu cuenta.</span>

                            <form>
                                <p v-if="error" class="help is-danger">Revisá los datos ingresados</p>

                                <b-field label="Password" :type="errors.has('password') ? 'is-danger' : ''" :message="errors.first('password')">
                                    <b-input v-model="password" key="password" name="password" type="password" password-reveal placeholder="Your password"></b-input>
                                </b-field>

                                <button class="button is-primary" :class="{ 'is-loading': isLoading }" v-on:click.prevent="onChangePassword">Guardar</button>
                            </form>
                        </div>
                    </div>

                    <div v-else class="column">
                        <!--Password request was sent-->
                        <div v-if="passwordRequested" class="box">
                            <h1 class="title">Recuperar cuenta</h1>
                            <span>Te enviamos un correo con un link para iniciar el cambio de contraseña de tu cuenta.</span>
                        </div>

                        <!--Password request form-->
                        <div v-else class="box">
                            <h1 class="title">Recuperar cuenta</h1>
                            <span>Ingresá la dirección de email con la que estas registrado y te enviaremos un correo para cambiar tu contraseña.</span>

                            <form>
                                <p v-if="error" class="help is-danger">Revisá los datos ingresados</p>

                                <b-field label="Email" :type="errors.has('email') ? 'is-danger' : ''" :message="errors.first('email')">
                                    <b-input v-model="email" key="email" name="email" type="email" placeholder=""></b-input>
                                </b-field>

                                <div class="has-text-centered">
                                    <button class="button is-primary" :class="{ 'is-loading': isLoading }" v-on:click.prevent="onRequestNewPassword">Recuperar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="column"></div>
                </div>
            </div>
        </template>

        <template slot="content">

        </template>
    </template-layout>
</template>

<script>
    import TemplateLayout from '../layout/TemplateLayout.vue';

    export default {
        name: 'login',

        data() {
            return {
                isLoading: false,
                error: false,
                errorType: '',

                email: '',
                password: '',
                code: '',

                passwordRequested: false,
                passwordChanged: false,
            }
        },

        components: {
            TemplateLayout
        },

        beforeRouteEnter(to, from, next) {
            if(Object.keys(to.query).length !== 0 && to.query.code !== '') {
                next(vm => {
                    vm.email = to.query.email;
                    vm.code = to.query.code;
                    next();
                });
            } else {
                next();
            }
        },

        methods: {
            onRequestNewPassword: function(/*e*/) {
                this.isLoading = true;

                this.$api.requestNewPassword(this.email).then((/*response*/) => {
                    this.passwordRequested = true;
                }).catch((response) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errorType = response.type;
                });
            },

            onChangePassword: function(/*e*/) {
                this.isLoading = true;

                this.$api.setNewPassword(this.email, this.code, this.password).then((/*response*/) => {
                    this.passwordChanged = true;
                }).catch((error) => {
                    this.isLoading = false;

                    if(error.code === 'error.request.invalid') {
                        this.errors.add({ field: 'password', msg: error.errors[''] });
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>